<script setup lang="ts"></script>

<template>
	<slot />
</template>
